import { render, staticRenderFns } from "./RequestOverDue.vue?vue&type=template&id=08e24e90"
import script from "./RequestOverDue.vue?vue&type=script&lang=js"
export * from "./RequestOverDue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports